var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckedPartialBold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "currentColor",
    fill: "currentColor",
    d: "m15,2c0.5523,0 1,0.44772 1,1l0,12c0,0.5523 -0.4477,1 -1,1l-12,0c-0.55228,0 -1,-0.4477 -1,-1l0,-12c0,-0.55228 0.44772,-1 1,-1l12,0zm-12,-1c-1.10457,0 -2,0.89543 -2,2l0,12c0,1.1046 0.89543,2 2,2l12,0c1.1046,0 2,-0.8954 2,-2l0,-12c0,-1.10457 -0.8954,-2 -2,-2l-12,0z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    x1: 4.18395,
    y1: 9,
    x2: 13.81605,
    y2: 9,
    strokeWidth: 2,
    stroke: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedPartialBold);
export default __webpack_public_path__ + "static/media/checked-partial-bold.eed15a43e71a16b0139bcd708f164d38.svg";
export { ForwardRef as ReactComponent };